export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#004aad] border-t-4 border-[#ffbd59]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/252ba0c726fdd5d02f883c440da24bd7/21e8579bce648dd00e21a709fde6a40a.jpeg" 
                alt="TechHeroesHub Logo" 
                className="h-16 w-auto mb-4 object-contain"
                style={{ mixBlendMode: 'multiply', filter: 'brightness(0) invert(1)' }}
              />
              <p className="text-white text-sm leading-relaxed">
                Your trusted partner for business growth and support
              </p>
            </div>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-all duration-300 cursor-pointer">
                <i className="ri-linkedin-fill text-white text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-all duration-300 cursor-pointer">
                <i className="ri-twitter-fill text-white text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-all duration-300 cursor-pointer">
                <i className="ri-facebook-fill text-white text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-all duration-300 cursor-pointer">
                <i className="ri-instagram-line text-white text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-white text-lg font-bold mb-6">Services</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white hover:underline transition-colors cursor-pointer text-sm">
                  Lead Generation
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white hover:underline transition-colors cursor-pointer text-sm">
                  Administrative Support
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white hover:underline transition-colors cursor-pointer text-sm">
                  Accounting & Payroll
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white hover:underline transition-colors cursor-pointer text-sm">
                  Design & Branding
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white hover:underline transition-colors cursor-pointer text-sm">
                  Marketing & Outreach
                </button>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 className="text-white text-lg font-bold mb-6">Company</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-white/80 hover:text-white hover:underline transition-colors cursor-pointer text-sm">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('why-choose-us')} className="text-white/80 hover:text-white hover:underline transition-colors cursor-pointer text-sm">
                  Why Choose Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('industries')} className="text-white/80 hover:text-white hover:underline transition-colors cursor-pointer text-sm">
                  Industries
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('how-it-works')} className="text-white/80 hover:text-white hover:underline transition-colors cursor-pointer text-sm">
                  How It Works
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-white/80 hover:text-white hover:underline transition-colors cursor-pointer text-sm">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-white text-lg font-bold mb-6">Get In Touch</h4>
            <div className="space-y-4">
              <a href="mailto:techheroeshub@gmail.com" className="flex items-start gap-3 text-white/80 hover:text-white transition-colors cursor-pointer group">
                <i className="ri-mail-line text-xl mt-0.5 group-hover:scale-110 transition-transform"></i>
                <span className="text-sm">techheroeshub@gmail.com</span>
              </a>
              <a href="https://wa.me/2349132216166" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 text-white/80 hover:text-white transition-colors cursor-pointer group">
                <i className="ri-whatsapp-line text-xl mt-0.5 group-hover:scale-110 transition-transform"></i>
                <span className="text-sm">+234 913 221 6166</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/20">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm">
            <div className="text-white/80">
              © 2025 TechHeroesHub. All Rights Reserved.
            </div>
            <div className="flex items-center gap-6">
              <a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <span className="text-white/40">|</span>
              <a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                Terms of Service
              </a>
              <span className="text-white/40">|</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}